exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EditorSettings___3pS3w {\n  display: flex;\n  flex: 1 0 auto;\n}\n\n.EditorLabel___36wf9 {\n  display: inline;\n  margin-right: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"EditorSettings": "EditorSettings___3pS3w",
	"EditorLabel": "EditorLabel___36wf9"
};